import { CouponCharts } from '../../../_metronic/partials/widgets/charts/CouponCharts'

const CouponReport = () => {
  return (
    <>
    <CouponCharts className='card-xl-stretch mb-xl-8' />
   </>
  )
}

export { CouponReport }
